import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentListHeader = _resolveComponent("DocumentListHeader")!
  const _component_DocumentFilterList = _resolveComponent("DocumentFilterList")!
  const _component_DocumentList = _resolveComponent("DocumentList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DocumentListHeader),
    _createVNode(_component_DocumentFilterList),
    _createVNode(_component_DocumentList)
  ], 64 /* STABLE_FRAGMENT */))
}